import React from "react";

interface InvalidReasonDisplayProps {
  reason: string | string[] | null | undefined;
  className?: string;
}

/**
 * Renders invalid_reason which can be a newline-separated string or an array.
 * Single reasons render as a span, multiple reasons render as a bulleted list.
 */
export const InvalidReasonDisplay: React.FC<InvalidReasonDisplayProps> = ({
  reason,
  className,
}) => {
  if (!reason) return null;

  let parsed: string[];
  if (Array.isArray(reason)) {
    parsed = reason;
  } else {
    const str = String(reason).trim();
    if (str.startsWith("[")) {
      try {
        const arr = JSON.parse(str);
        parsed = Array.isArray(arr) ? arr.map(String) : [str];
      } catch {
        parsed = str.split("\n");
      }
    } else {
      parsed = str.split("\n");
    }
  }
  const reasons = parsed.filter(Boolean);

  if (reasons.length === 0) return null;

  if (reasons.length === 1) {
    return <span className={className}>{reasons[0]}</span>;
  }

  return (
    <ul className={`list-disc pl-5 space-y-1 ${className ?? ""}`}>
      {reasons.map((r, i) => (
        <li key={i}>{r}</li>
      ))}
    </ul>
  );
};
